const { parseInt } = require("lodash")

function setView (tile = true) {
  const listNews = document.getElementById('listNews')
  const items = listNews.querySelectorAll('.post-card-wrapper')
  items.forEach(item => {
    if(tile) {
      item.classList.add('post-card-wrapper_tile')
    } else {
      item.classList.remove('post-card-wrapper_tile')
    }
  })
}

document.addEventListener('DOMContentLoaded', () => {
  const tileView = document.getElementById('tileView')
  const listView = document.getElementById('listView')
  if(tileView && listView) {
    tileView.addEventListener('click', () => {
      tileView.classList.toggle('news-view__button_active')
      listView.classList.toggle('news-view__button_active')
      localStorage.list_news = 0
      setView(true)
    })
    listView.addEventListener('click', () => {
      tileView.classList.toggle('news-view__button_active')
      listView.classList.toggle('news-view__button_active')
      localStorage.list_news = 1
      setView(false)
    })
    const type = localStorage.list_news
    if (parseInt(type) === 0) {
      tileView.classList.add('news-view__button_active')
      listView.classList.remove('news-view__button_active')
      setView(true)
    } else if (parseInt(type) === 1) {
      tileView.classList.remove('news-view__button_active')
      listView.classList.add('news-view__button_active')
      setView(false)
    }
  }
})